




















import {
  Component,
  Vue
} from "@/shared/vuepack";
import {
  FetchState,
  UserPermission
} from "@/shared/types";
import * as RouteNames from "@/admin/route-names";
import { useAdvisorStore } from "@/admin/store/advisor";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";


@Component({
  components: {}
})
export default class RuleList extends Vue {
  advisorStore = useAdvisorStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();

  pageNumber = 1;
  showFields = [
    {
      key: "name",
      label: "Name"
    },
    "actions"
  ];

  get allRules () {
    if (this.advisorStore.forceRefresh) {
      this.advisorStore.loadAllRules();
    }

    return this.advisorStore.rules;
  }

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
        ? this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalAdvisorEdit)
        : true;
  }

  mounted () {
    if (this.advisorStore.ruleFetchAllState === FetchState.Uninitialized) {
      this.advisorStore.loadAllRules();
    }
  }

  formatLink (id: number) {
    return { name: RouteNames.AdvisorRule3, params: { ruleId: id.toString() } };
  }

  get isLoading (): boolean {
    return this.advisorStore.ruleFetchAllState === FetchState.Loading;
  }
}
